var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex512X512(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    zoomAndPan: "magnify",
    viewBox: "0 0 384 383.999986",
    height: 512,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b8947dd85e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78 78 L 305 78 L 305 304 L 78 304 Z M 78 78 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "72f3990f24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 303.46875 201.324219 L 291.753906 201.324219 C 288.253906 201.324219 285.632812 202.136719 283.824219 203.441406 L 283.824219 201.324219 L 266.546875 201.324219 C 263.808594 201.324219 260.503906 201.984375 258.976562 203.441406 L 258.976562 201.324219 L 228.101562 201.324219 L 228.101562 203.441406 C 225.632812 201.699219 221.496094 201.324219 219.546875 201.324219 L 199.164062 201.324219 L 199.164062 203.441406 C 197.210938 201.5625 192.933594 201.324219 190.3125 201.324219 L 167.460938 201.324219 L 162.230469 206.96875 L 157.371094 201.324219 L 123.296875 201.324219 L 123.296875 238.132812 L 156.734375 238.132812 L 162.097656 232.402344 L 167.171875 238.117188 L 187.761719 238.132812 L 187.761719 229.453125 L 189.808594 229.453125 C 192.53125 229.453125 195.753906 229.390625 198.5625 228.1875 L 198.5625 238.132812 L 215.617188 238.132812 L 215.617188 228.5 L 216.449219 228.5 C 217.488281 228.488281 217.566406 228.578125 217.566406 229.5625 L 217.566406 238.132812 L 269.1875 238.132812 C 272.4375 238.132812 275.9375 237.292969 277.824219 235.804688 L 277.824219 238.132812 L 294.1875 238.132812 C 297.582031 238.132812 300.9375 237.644531 303.46875 236.445312 L 303.46875 303.886719 L 78.574219 303.886719 L 78.574219 192.730469 L 89.371094 192.730469 L 91.804688 186.828125 L 97.246094 186.828125 L 99.691406 192.730469 L 120.941406 192.730469 L 120.941406 188.242188 L 122.847656 192.742188 L 133.847656 192.742188 L 135.765625 188.167969 L 135.765625 192.730469 L 188.546875 192.730469 L 188.539062 183.097656 L 189.570312 183.097656 C 190.328125 183.097656 190.507812 183.1875 190.507812 184.355469 L 190.507812 192.730469 L 217.816406 192.730469 L 217.808594 190.445312 C 219.984375 191.625 223.402344 192.730469 227.949219 192.730469 L 239.433594 192.730469 L 241.914062 186.828125 L 247.355469 186.828125 L 249.800781 192.730469 L 271.875 192.730469 L 271.875 187.140625 L 275.265625 192.730469 L 292.996094 192.730469 L 292.996094 155.921875 L 275.460938 155.921875 L 275.460938 160.261719 L 272.949219 155.921875 L 254.929688 155.921875 L 254.929688 160.261719 L 252.71875 155.921875 L 228.378906 155.921875 C 224.28125 155.921875 220.671875 156.464844 217.808594 158.039062 L 217.808594 155.921875 L 201.035156 155.921875 L 201.035156 158.039062 C 199.128906 156.429688 196.648438 155.921875 193.875 155.921875 L 132.515625 155.921875 L 128.359375 165.414062 L 124.164062 155.921875 L 104.855469 155.921875 L 104.855469 160.261719 L 102.671875 155.921875 L 86.191406 155.921875 L 78.574219 173.378906 L 78.574219 78.675781 L 303.46875 78.675781 L 303.46875 201.324219 M 287.394531 187.535156 L 278.390625 187.535156 L 266.421875 167.738281 L 266.429688 187.535156 L 253.570312 187.535156 L 251.132812 181.621094 L 237.976562 181.621094 L 235.550781 187.535156 L 228.191406 187.535156 C 225.085938 187.535156 221.203125 186.820312 219 184.597656 C 216.78125 182.335938 215.652344 179.328125 215.652344 174.523438 C 215.652344 170.601562 216.351562 167.023438 219.042969 164.207031 C 221.078125 162.109375 224.308594 161.117188 228.667969 161.117188 L 234.707031 161.117188 L 234.707031 166.78125 L 228.792969 166.773438 C 226.457031 166.773438 225.140625 167.121094 223.90625 168.351562 C 222.792969 169.449219 222.050781 171.558594 222.050781 174.335938 C 222.050781 177.148438 222.605469 179.167969 223.851562 180.523438 C 224.78125 181.550781 226.535156 181.875 228.238281 181.875 L 231.074219 181.875 L 239.980469 161.117188 L 249.398438 161.117188 L 260.113281 186.097656 L 260.113281 161.117188 L 269.769531 161.117188 L 280.886719 179.507812 L 280.878906 161.117188 L 287.394531 161.117188 Z M 206.09375 187.535156 L 212.5625 187.535156 L 212.5625 161.109375 L 206.09375 161.109375 Z M 199.199219 162.394531 C 197.160156 161.234375 194.785156 161.117188 191.582031 161.117188 L 177.019531 161.117188 L 177.019531 187.535156 L 183.339844 187.535156 L 183.339844 177.917969 L 190.125 177.917969 C 192.425781 177.917969 193.8125 178.121094 194.714844 179.078125 C 195.886719 180.320312 195.753906 182.625 195.753906 184.195312 L 195.753906 187.535156 L 202.117188 187.535156 L 202.117188 182.292969 C 202.117188 179.996094 201.957031 178.78125 201.070312 177.507812 C 200.535156 176.738281 199.34375 175.792969 197.957031 175.265625 C 199.621094 174.613281 202.457031 172.441406 202.457031 168.253906 C 202.457031 165.296875 201.230469 163.566406 199.199219 162.394531 M 172.640625 182.015625 L 157.847656 182.035156 L 157.847656 176.800781 L 172.285156 176.808594 L 172.285156 171.378906 L 157.847656 171.378906 L 157.847656 166.621094 L 172.640625 166.621094 L 172.640625 161.117188 L 151.527344 161.117188 L 151.527344 187.535156 L 172.640625 187.535156 Z M 146.808594 161.117188 L 136.28125 161.117188 L 128.675781 179.035156 L 120.429688 161.117188 L 110.082031 161.117188 L 110.09375 186.105469 L 99.367188 161.117188 L 89.953125 161.117188 L 78.628906 187.535156 L 85.523438 187.535156 L 87.945312 181.621094 L 101.105469 181.621094 L 103.539062 187.535156 L 116.402344 187.535156 L 116.402344 166.824219 L 125.59375 187.535156 L 131.152344 187.535156 L 140.320312 166.851562 L 140.320312 187.535156 L 146.808594 187.535156 Z M 248.859375 176.121094 L 244.546875 165.628906 L 240.242188 176.121094 Z M 194.140625 171.953125 C 193.292969 172.460938 192.261719 172.496094 191.046875 172.496094 L 183.339844 172.496094 L 183.339844 166.621094 L 191.136719 166.621094 C 192.253906 166.621094 193.390625 166.65625 194.140625 167.074219 C 194.929688 167.511719 195.441406 168.324219 195.441406 169.441406 C 195.441406 170.578125 194.949219 171.488281 194.140625 171.953125 M 90.210938 176.121094 L 94.515625 165.628906 L 98.832031 176.121094 L 90.210938 176.121094 M 304.847656 224.613281 C 304.847656 230.230469 301.3125 232.925781 294.914062 232.925781 L 282.703125 232.925781 L 282.703125 227.265625 L 294.867188 227.265625 C 296.042969 227.265625 296.882812 227.105469 297.410156 226.621094 C 297.832031 226.230469 298.152344 225.640625 298.152344 224.898438 C 298.152344 224.113281 297.832031 223.523438 297.382812 223.148438 C 296.910156 222.746094 296.265625 222.585938 295.183594 222.558594 C 289.273438 222.398438 281.84375 222.746094 281.84375 214.371094 C 281.84375 210.585938 284.253906 206.511719 290.902344 206.511719 L 303.507812 206.511719 L 303.507812 212.183594 L 291.96875 212.183594 C 290.832031 212.183594 290.070312 212.21875 289.453125 212.628906 C 288.78125 213.066406 288.511719 213.691406 288.511719 214.539062 C 288.511719 215.523438 289.085938 216.210938 289.902344 216.496094 C 290.546875 216.71875 291.269531 216.773438 292.328125 216.789062 L 295.71875 216.878906 C 299.226562 216.960938 301.519531 217.539062 302.941406 219.003906 C 304.195312 220.316406 304.847656 221.863281 304.847656 224.613281 M 278.238281 219.003906 C 276.8125 217.550781 274.503906 216.960938 270.996094 216.878906 L 267.613281 216.789062 C 266.554688 216.773438 265.839844 216.71875 265.1875 216.496094 C 264.382812 216.210938 263.808594 215.523438 263.808594 214.539062 C 263.808594 213.691406 264.078125 213.066406 264.738281 212.628906 C 265.355469 212.21875 266.125 212.183594 267.273438 212.183594 L 278.863281 212.183594 L 278.863281 206.511719 L 266.199219 206.511719 C 259.546875 206.511719 257.140625 210.574219 257.140625 214.371094 C 257.140625 222.757812 264.570312 222.398438 270.46875 222.558594 C 271.550781 222.585938 272.203125 222.746094 272.671875 223.148438 C 273.117188 223.523438 273.449219 224.113281 273.449219 224.898438 C 273.449219 225.640625 273.117188 226.230469 272.695312 226.621094 C 272.167969 227.105469 271.335938 227.265625 270.15625 227.265625 L 257.882812 227.265625 L 257.882812 232.925781 L 270.199219 232.925781 C 276.597656 232.925781 280.136719 230.230469 280.136719 224.613281 C 280.136719 221.863281 279.492188 220.316406 278.238281 219.003906 M 254.125 227.433594 L 239.328125 227.425781 L 239.328125 222.210938 L 253.773438 222.210938 L 253.773438 216.773438 L 239.328125 216.78125 L 239.328125 212.023438 L 254.125 212.023438 L 254.125 206.511719 L 233.007812 206.511719 L 233.007812 232.925781 L 254.125 232.925781 Z M 226.25 207.796875 C 224.199219 206.628906 221.835938 206.511719 218.640625 206.511719 L 204.070312 206.511719 L 204.070312 232.925781 L 210.378906 232.925781 L 210.378906 223.328125 L 217.183594 223.320312 C 219.484375 223.320312 220.863281 223.523438 221.773438 224.46875 C 222.945312 225.722656 222.804688 228.015625 222.804688 229.585938 L 222.804688 232.925781 L 229.175781 232.925781 L 229.175781 227.695312 C 229.167969 225.398438 229.015625 224.183594 228.121094 222.90625 C 227.59375 222.132812 226.402344 221.183594 225.023438 220.65625 C 226.671875 220.003906 229.507812 217.84375 229.507812 213.648438 C 229.507812 210.699219 228.28125 208.96875 226.25 207.796875 M 190.464844 206.511719 L 170.253906 206.511719 L 162.1875 215.183594 L 154.4375 206.511719 L 128.980469 206.511719 L 128.980469 232.925781 L 154.042969 232.925781 L 162.125 224.21875 L 169.902344 232.925781 L 182.210938 232.925781 L 182.210938 224.085938 L 190.070312 224.085938 C 195.59375 224.085938 201.070312 222.558594 201.070312 215.246094 C 201.070312 207.941406 195.449219 206.511719 190.464844 206.511719 M 221.203125 217.363281 C 220.34375 217.851562 219.3125 217.890625 218.09375 217.890625 L 210.378906 217.898438 L 210.378906 212.023438 L 218.183594 212.023438 C 219.304688 212.023438 220.441406 212.058594 221.203125 212.46875 C 221.988281 212.914062 222.492188 213.726562 222.492188 214.84375 C 222.492188 215.976562 222 216.890625 221.203125 217.363281 M 190.390625 218.664062 L 182.210938 218.664062 L 182.210938 212.023438 L 190.464844 212.023438 C 192.726562 212.023438 194.285156 212.960938 194.285156 215.246094 C 194.285156 217.515625 192.800781 218.664062 190.390625 218.664062 M 166.207031 219.78125 L 175.890625 209.378906 L 175.890625 230.515625 Z M 150.835938 227.425781 L 135.308594 227.425781 L 135.308594 222.210938 L 149.15625 222.210938 L 149.15625 216.773438 L 135.308594 216.78125 L 135.308594 212.023438 L 151.113281 212.023438 L 158.050781 219.703125 L 150.835938 227.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0.711862, 0.761189, -0.701075, 0.652607, 62.154477, -109.442166)",
    gradientUnits: "userSpaceOnUse",
    r: 240.592269,
    cx: 190.474185,
    id: "51f28ac46c",
    cy: 117.475671,
    fx: 190.474185,
    fy: 117.475671
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.604797%, 82.615662%, 95.213318%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.316406%, 82.415771%, 95.100403%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.12262%, 82.281494%, 95.025635%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.930359%, 82.148743%, 94.950867%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.736572%, 82.015991%, 94.876099%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.544312%, 81.881714%, 94.801331%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.352051%, 81.748962%, 94.726562%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.158264%, 81.616211%, 94.650269%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.966003%, 81.481934%, 94.5755%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.772217%, 81.349182%, 94.500732%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.579956%, 81.216431%, 94.425964%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.386169%, 81.082153%, 94.351196%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.193909%, 80.949402%, 94.274902%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.000122%, 80.81665%, 94.200134%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.807861%, 80.682373%, 94.125366%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.614075%, 80.549622%, 94.050598%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.421814%, 80.41687%, 93.97583%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.228027%, 80.282593%, 93.901062%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.035767%, 80.149841%, 93.824768%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.84198%, 80.01709%, 93.75%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.649719%, 79.882812%, 93.675232%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.455933%, 79.750061%, 93.600464%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.263672%, 79.61731%, 93.525696%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.069885%, 79.483032%, 93.449402%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.877625%, 79.350281%, 93.374634%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.683838%, 79.217529%, 93.299866%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.491577%, 79.083252%, 93.225098%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.297791%, 78.9505%, 93.15033%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.10553%, 78.816223%, 93.075562%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.911743%, 78.683472%, 92.999268%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.719482%, 78.55072%, 92.9245%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.525696%, 78.416443%, 92.849731%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.333435%, 78.283691%, 92.774963%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.139648%, 78.15094%, 92.700195%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.947388%, 78.016663%, 92.625427%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.753601%, 77.883911%, 92.549133%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.56134%, 77.75116%, 92.474365%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.367554%, 77.616882%, 92.399597%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.175293%, 77.484131%, 92.324829%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.981506%, 77.351379%, 92.250061%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.789246%, 77.217102%, 92.173767%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.595459%, 77.084351%, 92.098999%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.403198%, 76.951599%, 92.024231%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.209412%, 76.817322%, 91.949463%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.017151%, 76.68457%, 91.874695%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.823364%, 76.551819%, 91.799927%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.631104%, 76.417542%, 91.723633%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.437317%, 76.28479%, 91.648865%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.245056%, 76.152039%, 91.574097%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.05127%, 76.017761%, 91.499329%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.859009%, 75.88501%, 91.424561%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.665222%, 75.750732%, 91.349792%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.472961%, 75.617981%, 91.273499%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.280701%, 75.485229%, 91.19873%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.086914%, 75.350952%, 91.123962%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.894653%, 75.218201%, 91.049194%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.700867%, 75.085449%, 90.974426%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.508606%, 74.951172%, 90.898132%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.314819%, 74.81842%, 90.823364%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.122559%, 74.685669%, 90.748596%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.928772%, 74.551392%, 90.673828%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.736511%, 74.41864%, 90.59906%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.542725%, 74.285889%, 90.524292%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.350464%, 74.151611%, 90.447998%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.060547%, 73.951721%, 90.336609%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.6745%, 73.686218%, 90.187073%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.288452%, 73.419189%, 90.036011%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.902405%, 73.152161%, 89.886475%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.516357%, 72.886658%, 89.735413%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.13031%, 72.619629%, 89.585876%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.744263%, 72.3526%, 89.43634%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.358215%, 72.085571%, 89.285278%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.972168%, 71.820068%, 89.135742%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.586121%, 71.55304%, 88.986206%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.200073%, 71.286011%, 88.835144%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.814026%, 71.020508%, 88.685608%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.427979%, 70.753479%, 88.536072%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.041931%, 70.48645%, 88.38501%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.655884%, 70.220947%, 88.235474%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.269836%, 69.953918%, 88.085938%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.883789%, 69.68689%, 87.934875%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.497742%, 69.419861%, 87.785339%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.111694%, 69.154358%, 87.634277%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.725647%, 68.887329%, 87.484741%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.3396%, 68.6203%, 87.335205%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.953552%, 68.354797%, 87.184143%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.567505%, 68.087769%, 87.034607%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.181458%, 67.82074%, 86.885071%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.79541%, 67.555237%, 86.734009%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.409363%, 67.288208%, 86.584473%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.023315%, 67.021179%, 86.434937%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.637268%, 66.755676%, 86.283875%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.251221%, 66.488647%, 86.134338%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.865173%, 66.221619%, 85.984802%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.479126%, 65.95459%, 85.83374%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.093079%, 65.689087%, 85.684204%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.804688%, 65.489197%, 85.571289%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.610901%, 65.354919%, 85.496521%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.41864%, 65.222168%, 85.420227%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.224854%, 65.089417%, 85.345459%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.032593%, 64.955139%, 85.270691%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.838806%, 64.822388%, 85.195923%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.646545%, 64.689636%, 85.121155%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.452759%, 64.555359%, 85.046387%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.260498%, 64.422607%, 84.970093%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.066711%, 64.289856%, 84.895325%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.874451%, 64.155579%, 84.820557%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.680664%, 64.022827%, 84.745789%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.488403%, 63.890076%, 84.671021%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.294617%, 63.755798%, 84.596252%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.102356%, 63.623047%, 84.519958%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.908569%, 63.490295%, 84.44519%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.716309%, 63.356018%, 84.370422%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.522522%, 63.223267%, 84.295654%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.330261%, 63.090515%, 84.220886%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.136475%, 62.956238%, 84.144592%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.944214%, 62.823486%, 84.069824%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.750427%, 62.689209%, 83.995056%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.558167%, 62.556458%, 83.920288%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.365906%, 62.423706%, 83.84552%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.172119%, 62.289429%, 83.770752%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.979858%, 62.156677%, 83.694458%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.786072%, 62.023926%, 83.61969%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.593811%, 61.889648%, 83.544922%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.400024%, 61.756897%, 83.470154%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.207764%, 61.624146%, 83.395386%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.013977%, 61.489868%, 83.320618%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.821716%, 61.357117%, 83.244324%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.531799%, 61.157227%, 83.132935%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.145752%, 60.890198%, 82.981873%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.759705%, 60.624695%, 82.832336%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.373657%, 60.357666%, 82.6828%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.98761%, 60.090637%, 82.531738%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.601562%, 59.823608%, 82.382202%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.215515%, 59.558105%, 82.232666%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.829468%, 59.291077%, 82.081604%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.44342%, 59.024048%, 81.932068%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.057373%, 58.758545%, 81.782532%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.671326%, 58.491516%, 81.63147%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.285278%, 58.224487%, 81.481934%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.899231%, 57.958984%, 81.332397%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.513184%, 57.691956%, 81.181335%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.127136%, 57.424927%, 81.031799%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.741089%, 57.159424%, 80.880737%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.451172%, 56.959534%, 80.767822%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.258911%, 56.825256%, 80.693054%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.065125%, 56.692505%, 80.618286%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.872864%, 56.558228%, 80.543518%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.679077%, 56.425476%, 80.46875%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.486816%, 56.292725%, 80.393982%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.294556%, 56.158447%, 80.317688%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.100769%, 56.025696%, 80.24292%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.908508%, 55.892944%, 80.168152%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.714722%, 55.758667%, 80.093384%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.522461%, 55.625916%, 80.018616%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.328674%, 55.493164%, 79.943848%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.136414%, 55.358887%, 79.867554%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.942627%, 55.226135%, 79.792786%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.750366%, 55.093384%, 79.718018%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.55658%, 54.959106%, 79.64325%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.266663%, 54.759216%, 79.530334%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.880615%, 54.493713%, 79.380798%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.494568%, 54.226685%, 79.231262%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.108521%, 53.959656%, 79.0802%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.722473%, 53.694153%, 78.930664%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.336426%, 53.427124%, 78.781128%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.950378%, 53.160095%, 78.630066%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.564331%, 52.893066%, 78.48053%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.27594%, 52.693176%, 78.367615%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.082153%, 52.560425%, 78.292847%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.889893%, 52.427673%, 78.216553%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.696106%, 52.293396%, 78.141785%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.503845%, 52.160645%, 78.067017%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.310059%, 52.027893%, 77.992249%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.117798%, 51.893616%, 77.91748%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.924011%, 51.760864%, 77.842712%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.634094%, 51.560974%, 77.729797%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.248047%, 51.293945%, 77.580261%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.862%, 51.028442%, 77.429199%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.475952%, 50.761414%, 77.279663%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.187561%, 50.561523%, 77.166748%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.993774%, 50.428772%, 77.09198%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.801514%, 50.294495%, 77.017212%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.607727%, 50.161743%, 76.940918%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.31781%, 49.961853%, 76.829529%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.933289%, 49.694824%, 76.679993%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.643372%, 49.494934%, 76.567078%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.451111%, 49.362183%, 76.490784%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.161194%, 49.162292%, 76.379395%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.871277%, 48.962402%, 76.266479%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.58136%, 48.762512%, 76.153564%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.389099%, 48.629761%, 76.078796%)",
    offset: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 78.574219 78.675781 L 303.46875 78.675781 L 303.46875 303.886719 L 78.574219 303.886719 Z M 78.574219 78.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1790cd",
    d: "M 64.128906 299.226562 L 62.148438 299.226562 C 61.898438 298.429688 61.855469 296.949219 61.855469 296.589844 C 61.855469 295.867188 61.738281 295.128906 60.386719 295.128906 L 57.476562 295.128906 L 57.476562 299.226562 L 55.734375 299.226562 L 55.734375 289.222656 L 60.386719 289.222656 C 61.980469 289.222656 63.753906 289.785156 63.753906 292.011719 C 63.753906 293.269531 63.222656 293.875 62.667969 294.261719 C 63.125 294.519531 63.519531 294.949219 63.574219 296.082031 L 63.644531 297.816406 C 63.664062 298.316406 63.714844 298.414062 64.128906 298.644531 Z M 61.972656 292.144531 C 61.972656 290.886719 61.101562 290.777344 60.476562 290.777344 L 57.476562 290.777344 L 57.476562 293.5625 L 60.253906 293.5625 C 61.175781 293.5625 61.972656 293.351562 61.972656 292.144531 M 70.207031 294.332031 C 70.207031 288.410156 65.390625 283.667969 59.457031 283.667969 C 53.523438 283.667969 48.714844 288.410156 48.714844 294.332031 C 48.714844 300.253906 53.523438 304.984375 59.457031 304.984375 C 65.390625 304.984375 70.207031 300.253906 70.207031 294.332031 M 68.578125 294.332031 C 68.578125 299.359375 64.710938 303.433594 59.457031 303.433594 C 54.210938 303.433594 50.34375 299.359375 50.34375 294.332031 C 50.34375 289.304688 54.191406 285.230469 59.457031 285.230469 C 64.726562 285.230469 68.578125 289.304688 68.578125 294.332031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8947dd85e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#72f3990f24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#51f28ac46c)",
    d: "M 199.542969 -33.929688 L -34.023438 183.488281 L 183.882812 416.492188 L 417.445312 199.074219 Z M 199.542969 -33.929688 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex512X512);
export default __webpack_public_path__ + "static/media/amex-512x512.2f0f2060d81b95c67c2d92fb8df7fb40.svg";
export { ForwardRef as ReactComponent };